var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:[_vm.will_flip && 'flip', _vm.color]},[_c('svg',{attrs:{"viewBox":"0 0 100 100","fill":"currentColor"}},[_c('circle',{attrs:{"cx":"50","cy":"50","r":"50"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }